import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMore: {
		id: 'confluence-pages-readview-full.ui.confluence-pages.show-more',
		defaultMessage: 'Show more',
		description: 'Tooltip for the Confluence pages show more button',
	},
});
